import React, { useState, useEffect } from 'react';

import CardContext from './CardContext';
import SepaContext from './SepaContext';

const translate = trKey => window.VULOG_TRANSLATE(trKey);

const MOPSelection = ({ openMethod, title, icon, selected }) => {
    const cardClasses = selected
        ? 'stripeSelectionItem card stripeSelectionItem--selected'
        : 'stripeSelectionItem card';
    return (
        <div className="col">
            <div className={cardClasses} onClick={openMethod}>
                <div className={'card-body'}>
                    <i className="material-icons va-middle reg">{icon}</i>
                    <p className={'card-text'}>{title}</p>
                </div>
            </div>
        </div>
    );
};

const StripeContainer = ({ history }) => {
    const [selectedMop, setSelectedMop] = useState('card');

    const paymentMethods = (window.VULOG_CONFIG && window.VULOG_CONFIG.STRIPE_PAYMENT_METHODS) || [];

    useEffect(() => {
        const updatePaymentMethod = () => {
            if (paymentMethods.length === 1) {
                setSelectedMop(paymentMethods[0]);
            }
        };
        updatePaymentMethod();
    }, [paymentMethods]);

    return (
        <div className={'container-fluid'} id={'stripe'}>
            <h3 className="page__title">{window.VULOG_TRANSLATE('PAYMENT DETAILS')}</h3>

            {paymentMethods.length > 1 && (
                <div className={'row'}>
                    <MOPSelection
                        openMethod={() => setSelectedMop('card')}
                        title={translate('Credit Card')}
                        icon={'credit_card'}
                        selected={selectedMop === 'card'}
                    />
                    <MOPSelection
                        openMethod={() => setSelectedMop('sepa')}
                        title={translate('SEPA')}
                        icon={'account_balance'}
                        selected={selectedMop === 'sepa'}
                    />
                </div>
            )}

            {selectedMop === 'card' && <CardContext history={history} />}
            {selectedMop === 'sepa' && <SepaContext history={history} />}
        </div>
    );
};

export default StripeContainer;
